//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { convertTime } from '../../../components/helpers.js'

export default {
  props: {
    report: {
      type: Object,
      default () {
        return {}
      }
    },
    withoutServiceObject: {
      default: false,
      type: Boolean
    },
    serviceObjectType: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      images: []
    }
  },
  created: function () {
    if (this.report.documents != null) {
      for (let i = 0; i < this.report.documents.length; i++) {
        const document = this.report.documents[i]

        if (this.isImage(document.contentType)) {
          this.images.push({
            url: '/service/fileobj/read/' + document.id,
            name: this.report.name + '-' + (this.images.length + 1) + '.' + document.contentType.split('/')[1]
          })
        }
      }
    }
  },
  methods: {
    convertTimeReactive: convertTime,
    isImage: function (str) {
      return str != null && str.startsWith('image/')
    },
    openReportInDelta1: function () {
      if (this.serviceObjectType !== 'TOI') {
        window.open('https://delta.spetsdor.ru/index.php?r=act%2Fview&id=' + this.report.id, '_blank')
      } else {
        window.open('https://delta.spetsdor.ru/index.php?r=act-toi%2Fview&id=' + this.report.id, '_blank')
      }
    }
  }
}

